import React, {Component} from "react";
import * as prosConnect from "./ProsConnect";
import {strYesNoValue} from "./ProsCommonUi"
import {ATTR_OBJ_ID, ATTR_OBJ_TYPE} from "./ProsConnect";
import DropdownMenu from "../components/DropdownMenu";

export default class ProsChTag extends Component {

    async saveObs(selectedState) {
        let attrChanges = {
            [ATTR_OBJ_ID]: this.props.obs[ATTR_OBJ_ID],
            [ATTR_OBJ_TYPE]: this.props.obs[ATTR_OBJ_TYPE],
            [this.props.tag]: strYesNoValue(selectedState)
        }
        await prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChanges])
    }

    permissionToEditTag() {
        return this.props.project.getMayEditCheckBoxOrText(this.props.tag)
    }

    render() {
        let selectedState = this.props.obs[this.props.tag] === prosConnect.STR_YES
        if (!selectedState) {
            return null
        }
        const chTagOptions = [{
                value: prosConnect.STR_YES,
                text: 'Poista valinta',
                icon: 'times',
                action: ()=>{
                    this.saveObs(false)
                }
            }
        ]
        let btnType = this.permissionToEditTag() ? null : "locked"
        return <DropdownMenu
            values={chTagOptions}
            text={this.props.project.getChTagLabels()[this.props.tagIndex]}
            disabled={this.props.disabled || (this.props.project && !this.props.project.getMayEditCheckBoxOrText(this.props.tag))}
            btnType={btnType}
            btnClass={"3rd"}
        />
    }
}